import { createListenCollectionEpic, createListenDocEpic } from 'src/firebase';
import { actions, actionTypes } from './redux';

const ListenTownshipsEpic$ = createListenCollectionEpic({
  collection: 'townships',
  listenType: actionTypes.LISTEN_COLLECTION,
  unlistenType: actionTypes.UNLISTEN_COLLECTION,
  changeCollection: actions.changeCollection,
});

const ListenTownshipDetailEpic$ = createListenDocEpic({
  collection: 'townships',
  listenType: actionTypes.LISTEN_DOC,
  unlistenType: actionTypes.UNLISTEN_DOC,
  changeDoc: actions.changeDoc,
});

export {
  ListenTownshipsEpic$,
  ListenTownshipDetailEpic$
};



// WEBPACK FOOTER //
// ./src/townships/epics.ts